import {
  Container,
  Box,
  Header,
  Button,
  Grid,
  SpaceBetween,
  Link,
  SegmentedControl,
  StatusIndicator,
  Icon,
  Input,
  Alert,
  Table,
  Pagination,
  ExpandableSection,
  FormField,
  Autosuggest,
  TokenGroup,
} from '@cloudscape-design/components';

import { useGoogleMapsSuggestions, type Suggestion } from '../common/useMaps';


export type AutoCompleteSearchProps = {
  loading?: boolean;
  selectedItems: Suggestion[];
  setSelectedItems: (items: Suggestion[]) => void;
  searchDisabled?: boolean;
  hideSearch?: boolean;
  placeholder?: string;
};

export default function AutoCompleteSearch(props: AutoCompleteSearchProps) {
  const { loading, selectedItems, setSelectedItems, searchDisabled, hideSearch } = props;
  const { name, setName, options, setOptions, status, loadSuggestions } = useGoogleMapsSuggestions({ selectedItems, setSelectedItems });


  return (
    <div>
      <SpaceBetween direction="vertical" size="s">
        {!hideSearch && (
          <Autosuggest
            className="pt-2"
            disabled={loading || searchDisabled}
            placeholder={props.placeholder ?? 'Enter a business name...'}
            autoFocus={false}
            ariaLabel="Autosuggest for business name"
            empty={name.trim() ? <Box variant="p">No matches found</Box> : undefined}
            filteringType="manual"
            onChange={({ detail }) => {
              setName(detail.value);
            }}
            // The statusType prop can be set using our local status state.
            statusType={status}
            // onLoadItems is triggered to load suggestions when needed.
            onLoadItems={({ detail }) => {
              loadSuggestions(detail.filteringText);
            }}
            value={name}
            // Options provided to the autosuggest component are the suggestions.
            options={options}
            loadingText="Loading suggestions..."
            errorText="Error loading suggestions, please try again."
            // finishedText="No more suggestions."
            recoveryText="Try again"
            hideEnteredTextOption
            onSelect={async ({ detail }) => {
              const suggestion = options.find((option) => option.value === detail.value);
              if (suggestion) {
                setName(name);
                if (!selectedItems.some((item) => item.placeId === suggestion.placeId)) {
                  setOptions((options) =>
                    options.filter((option) => option.placeId !== suggestion.placeId),
                  );
                  // TODO consider loading status here
                  setSelectedItems([...selectedItems, suggestion]);
                  const place = new google.maps.places.Place({
                    id: suggestion.placeId,
                  });
                  try {
                    await place.fetchFields({ fields: ['formattedAddress'] });
                    suggestion.description = place.formattedAddress ?? suggestion.description;
                    setSelectedItems([...selectedItems, suggestion]);
                  } catch (error) {
                    console.error('Error loading place details', error);
                  }
                }
              }
            }}
          />
        )}
        <TokenGroup
          onDismiss={({ detail: { itemIndex } }) => {
            setSelectedItems([
              ...selectedItems.slice(0, itemIndex),
              ...selectedItems.slice(itemIndex + 1),
            ]);
          }}
          items={selectedItems}
          readOnly={loading}
        />
      </SpaceBetween>
      <div id="hidden-map" style={{ display: 'none' }} />
    </div>
  );
}
